import React from "react";
import { useTheme } from "react-jss";
import { ProgressBarStyle } from "./progresBarStyle.jss";
import truck from "../../assets/image/simplyTruck.png";
interface IProgressBar {
    percent: number;
}
const ProgressBar: React.FC<IProgressBar> = (props) => {
    const { percent } = props;
    const theme = useTheme();
    const style = ProgressBarStyle({ theme });
    return (
        <div className={style.progressBar}>
            <div
                className={style.progressBarFill}
                style={{ width: `${percent}%`, display: "flex", justifyContent: "end", padding:3, maxWidth:"100%" }}
            >
                <img src={truck}></img>
            </div>
        </div>
    );
};

export default ProgressBar;
